import { render, staticRenderFns } from "./UnsupportedMessage.vue?vue&type=template&id=9f8da7be&scoped=true"
import script from "./UnsupportedMessage.vue?vue&type=script&lang=js"
export * from "./UnsupportedMessage.vue?vue&type=script&lang=js"
import style0 from "./UnsupportedMessage.vue?vue&type=style&index=0&id=9f8da7be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8da7be",
  null
  
)

export default component.exports